// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"4ef73dbc","453":"8135c35e"}[chunkId] + ".chunk.js";
};